import { Subject } from 'rxjs';
import { GenericResponse } from 'src/app/data/repository/generic-response';
import { SupportApiService } from './support-api.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SupportService {
  constructor(private supportApiService: SupportApiService) {}

  public messageBS: Subject<boolean> = new Subject();

  getSupportCategories(): Promise<GenericResponse> {
    return this.supportApiService.getCategories();
  }
  getFaqSubCategories(id: string): Promise<GenericResponse> {
    return this.supportApiService.getSubCategories(id);
  }
  getFaqSearchResponce(query: string): Promise<GenericResponse> {
    return this.supportApiService.getSearchResult(query);
  }
  getFaqAnswer(id: string) {
    return this.supportApiService.getFaqAnswer(id);
  }
  getMessageBadge() {
    return this.supportApiService.getMessageBadge();
  }
  getMessageInbox() {
    return this.supportApiService.getMessageInbox();
  }
  sendVoteFaq(id: string, isLiked: boolean) {
    return this.supportApiService.sendVoteFaq(id, isLiked);
  }
  deleteVoteFaq(id: string) {
    return this.supportApiService.deleteVoteFaq(id);
  }
  updateMessage(
    id: string,
    userReaction: 'noReaction' | 'like' | 'dislike' | null,
    readByUser: boolean
  ) {
    return this.supportApiService.updateMessage(id, userReaction, readByUser);
  }
  sendMessage(text: string, faqId: string | null): Promise<GenericResponse> {
    return this.supportApiService.senMessage(text, faqId);
  }
}
